import React, { useEffect } from 'react';
import useDebounce from "../../hooks/useDebounce";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import QuantityPicker from 'src/component/custom/QuantityPicker';
import { __set, __remove } from "src/store/axios_indicator";

const QuantityPickerForUpdateCart = (props) => {
    const { single_product, single_cart_data, single_product_inventory } = props;
    const [{ }, { update_To_Cart_Server }, {   set_cart_loader_data_object }] = useCartStore();
    const [countQuantityPicker, setCountQuantityPicker] = useDebounce(0, 1000)
    const [{ }, {  get_inventory_by_distributor }, { },] = useProductInventoryPriceStore();

    useEffect(() => {
        async function f() {
            if (countQuantityPicker > 0) {
                await updateToCartServer(countQuantityPicker);
            }
        }
        f();
    }, [countQuantityPicker]);

    const updateToCartServer = async (quantityUpdateToCartInput) => {
        set_cart_loader_data_object({ ...single_product, isUpdatingCpnType: !single_product?.isUpdatingCpnType })
        
        __set('UPDATE_CART_QTY_API_CALL');

        if (single_cart_data && quantityUpdateToCartInput && quantityUpdateToCartInput > 0 && single_product.ERPPartNumber) {
            let p = {
                ...single_cart_data,
                "partNumber": single_product.ERPPartNumber,
                "quantity": quantityUpdateToCartInput,
                "cartDetailId": single_cart_data.cartDetailId,
                isSoftwareDownloadable: single_product?.softwareDownloadFlag
            };
            if (single_cart_data.backOrderedQuantity && single_cart_data.backOrderedQuantity > 0) {
                let b_q = quantityUpdateToCartInput - (get_inventory_by_distributor(single_product, single_product_inventory))
                if (b_q < 1) {
                    b_q = 0;
                }
                p.backOrderedQuantity = b_q;
                p.quantity = quantityUpdateToCartInput;
            }
            await update_To_Cart_Server(p)
        }
        __remove('UPDATE_CART_QTY_API_CALL');
    };

    const [__check] = useAxiosIndicatorCheck();
    return (
        <>
            {single_cart_data && single_product &&
                <QuantityPicker
                    {...props}
                    invalid_quantity_message_text={"An invalid quantity was entered."}
                    readOnly_quantity={__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status}
                    CHECK_CART_RELATED_INVENTORY_VALIDATION={true}
                    force_default_quantity={single_cart_data.quantity}
                    disable_edit_force_default_quantity={true}
                    getPlanInputQuantityValidatedCallback={async (count) => {
                        setCountQuantityPicker(count)
                    }}
                />
            }
        </>
    );
}

export default QuantityPickerForUpdateCart;